import Service from '@/helpers/service'

export default {
    get(page, params) {
        return Service().get('Bin?page=' + page, {params});
    }, 
    show(id) {
        return Service().get('Bin/show/'+id);
    },    
    create(params) {
        return Service().post('Bin/create', params);
    },
    update(id, params) {
        return Service().post('Bin/update/'+id, params);
    },
    delete(id) {
        return Service().post('Bin/delete/'+id);
    }
}